import { cloneDeep } from "lodash";

const PUSH_MARKETS = "app/markets/PUSH_MARKETS";
const RESET_MARKETS = "app/markets/RESET_MARKETS";
const SET_LOADING = "app/markets/SET_LOADING";
const SET_REFRESH = "app/markets/SET_REFRESH";
const SET_ERROR = "app/markets/SET_ERROR";

const initialState = {
  markets: null,
  loading: false,
  refresh: false,
  error: null
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case PUSH_MARKETS: {
      const clonedState = cloneDeep(state);

      return {
        ...clonedState,
        markets: action.payload
      };
    }

    case RESET_MARKETS: {
      const clonedState = cloneDeep(state);

      return {
        ...clonedState,
        markets: null
      };
    }

    case SET_REFRESH: {
      const clonedState = cloneDeep(state);

      return {
        ...clonedState,
        refresh: action.payload
      };
    }

    case SET_LOADING: {
      const clonedState = cloneDeep(state);

      return {
        ...clonedState,
        loading: action.payload
      };
    }

    case SET_ERROR: {
      const clonedState = cloneDeep(state);

      return {
        ...clonedState,
        error: action.payload
      };
    }

    default: {
      return state;
    }
  }
}

export const pushMarkets = (markets) => ({ type: PUSH_MARKETS, payload: markets });

export const resetMarkets = () => ({ type: RESET_MARKETS });

export const setLoading = (loading) => ({ type: SET_LOADING, payload: loading });

export const setRefresh = (refresh) => ({ type: SET_REFRESH, payload: refresh });

export const setError = (error) => ({ type: SET_ERROR, payload: error });
